"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORTHOGRAPHIC_CAMERA_DIRECTION = exports.CAMERA_TYPE = void 0;
var CAMERA_TYPE;
(function (CAMERA_TYPE) {
    CAMERA_TYPE["PERSPECTIVE"] = "perspective";
    CAMERA_TYPE["ORTHOGRAPHIC"] = "orthographic";
})(CAMERA_TYPE || (exports.CAMERA_TYPE = CAMERA_TYPE = {}));
var ORTHOGRAPHIC_CAMERA_DIRECTION;
(function (ORTHOGRAPHIC_CAMERA_DIRECTION) {
    ORTHOGRAPHIC_CAMERA_DIRECTION["TOP"] = "top";
    ORTHOGRAPHIC_CAMERA_DIRECTION["BOTTOM"] = "bottom";
    ORTHOGRAPHIC_CAMERA_DIRECTION["LEFT"] = "left";
    ORTHOGRAPHIC_CAMERA_DIRECTION["RIGHT"] = "right";
    ORTHOGRAPHIC_CAMERA_DIRECTION["FRONT"] = "front";
    ORTHOGRAPHIC_CAMERA_DIRECTION["BACK"] = "back";
    ORTHOGRAPHIC_CAMERA_DIRECTION["CUSTOM"] = "custom";
})(ORTHOGRAPHIC_CAMERA_DIRECTION || (exports.ORTHOGRAPHIC_CAMERA_DIRECTION = ORTHOGRAPHIC_CAMERA_DIRECTION = {}));
//# sourceMappingURL=cameraTypes.js.map